import { useEffect, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { profilData, profilUpdate } from "../../Store/Actions/ProfileActions";
import { ResumeUpdateContext } from "../../Context/resumeUpdateContext";
import axios from "axios";

const ProfileForm = (section, resumeFields, setResumeFields, resumeUpdate) => {
  const dispatch = useDispatch();
  const editorData = useSelector((state) => state.editorData.profile);
  const [profileFields, setProfileFields] = useState(editorData);
  const [fileUploadError, setFileUploadError] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [disableSave, setDisableSave] = useState(false);
  const loginData = useSelector((state) => state.userData.userInfo);
  const baseUrl = process.env.REACT_APP_API_URL;
  const [profileImage, setProfileImage] = useState("");

  const [profileChanged, setProfileChanged] = useState(false);

  const { setResumeUpdated } = useContext(ResumeUpdateContext);

  const fileUpload = (file, type, index) => {
    const body = new FormData();
    body.append("image", file);
    body.append("type", "image");
    if (type == "profile") {
      body.append(
        "img_delete",
        resumeFields &&
          resumeFields["profile"] &&
          resumeFields["profile"].data &&
          resumeFields["profile"].data[0] &&
          resumeFields["profile"].data[0]["photo"]
      );
    }
    if (typeof file !== "undefined") {
      axios({
        method: "post",
        url: baseUrl + "/api/fileupload",
        data: body,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${loginData.token}`,
        },
      })
        .then(function (response) {
          if (type == "books") {
            let data = { ...resumeFields, initialLoad: false };
            data[section].data[index]["image"] = response.data.data.key;
            setResumeFields(data);
            resumeUpdate(true);
            setModalShow(false);
            setFileUploadError("");
            setDisableSave(false);
          } else {
            let data = { ...resumeFields, initialLoad: false };
            data[section].data[0]["photo"] = response.data.data.key;
            if (data[section]?.data[0]?.showFields?.hasOwnProperty("photo")) {
              data[section].data[0].showFields.photo = true;
            }

            setResumeFields(data);
            resumeUpdate(true);
            setModalShow(false);
            setFileUploadError("");
            setDisableSave(false);
          }
        })
        .catch(function (error) {
          setDisableSave(false);
          setFileUploadError(error.response.data);
        });
    }
  };

  const resetImage = () => {
    let data = { ...profileFields, initialLoad: false };
    data.data[0]["photo"] = "";
    setProfileFields(data);
  };

  useEffect(() => {
    setProfileFields(editorData);
    if (profileChanged) {
      setProfileChanged(false);
      profileUpdate();
    }
  }, [editorData]);

  //   useEffect(() => {
  //     if (profileFields && !profileFields.initialLoad) {
  //       dispatch(profilData(profileFields));
  //       setProfileChanged(true);
  //     }

  //     if (profileFields && profileFields.data && profileFields.data[0]) {
  //       setProfileImage(profileFields.data && profileFields.data[0]["photo"]);
  //     }
  //   }, [profileFields]);

  const profileUpdate = () => {
    setResumeUpdated(Math.random());
  };

  return {
    profileFields,
    profileUpdate,
    fileUpload,
    resetImage,
    modalShow,
    setModalShow,
    profileImage,
    setProfileImage,
    fileUploadError,
    setFileUploadError,
    disableSave,
    setDisableSave,
  };
};

export default ProfileForm;
